import type { Move } from './types';
import { darkenIt } from './moves/darken-it';
import { delayTheArrival } from './moves/delay-the-arrival';
import { suspendIntoIt } from './moves/suspend-into-it';
import { letTheBassHold } from './moves/let-the-bass-hold';
import { brightenTheEnding } from './moves/brighten-the-ending';
import { takeTheLongWayHome } from './moves/take-the-long-way-home';
import { widenIt } from './moves/widen-it';
import { thinIt } from './moves/thin-it';
import { walkTheBass } from './moves/walk-the-bass';
import { sidestep } from './moves/sidestep';

export const MOVES: Move[] = [
  darkenIt,
  delayTheArrival,
  suspendIntoIt,
  letTheBassHold,
  brightenTheEnding,
  takeTheLongWayHome,
  widenIt,
  thinIt,
  walkTheBass,
  sidestep,
];

export type { Move, MoveContext, MoveResult } from './types';
